import { errorHandling } from '../../helpers/errorHandling';
import { ApolloClientPromoService } from '../../services/ApolloClientPromoService';
import {
  GET_ORGANIZATION_TREE,
  GET_COUNTRIES,
  CREATE_OR_UPDATE_COUNTRY,
  GET_ORGANIZATIONS,
  CREATE_OR_UPDATE_BRAND,
  GET_BRANDS,
  CREATE_ORGANIZATION,
  CREATE_OR_UPDATE_STORE,
  CREATE_OR_UPDATE_PERMISSION,
  GET_PERMISSIONS,
  CREATE_OR_UPDATE_ROLE,
  GET_ROLES,
  GET_STORES,
} from '../../gql/organization';
import {
  setOrganizationTree,
  setCountries,
  setIsRefreshCountry,
  setOrganizations,
  setIsRefreshBrands,
  setBrands,
  setIsRefreshOrganizations,
  setIsRefreshStores,
  setIsRefreshOrganizationTree,
  setStores,
} from '../../slices/organization/reducer';

export const getOrganizationTree = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.query({
      query: GET_ORGANIZATION_TREE,
      operationName: 'GET_ORGANIZATION_TREE',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const organizationTree = data?.getOrganizationTree || {};
    if (input?.isMenu !== true) {
      dispatch(setOrganizationTree(organizationTree));
    }
    return organizationTree;
  } catch (error) {
    errorHandling(error);
  }
};

export const getOrganizations = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.query({
      query: GET_ORGANIZATIONS,
      operationName: 'GET_ORGANIZATIONS',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const organizations = data?.organizations || {};
    dispatch(setOrganizations(organizations));
    return organizations;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};

export const getCountries = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.query({
      query: GET_COUNTRIES,
      operationName: 'GET_COUNTRIES',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const countries = data?.countries || {};
    dispatch(setCountries(countries));
    return countries;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};

export const getStores = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.query({
      query: GET_STORES,
      operationName: 'GET_STORES',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const stores = data?.stores || {};
    dispatch(setStores(stores));
    return stores;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};

export const createOrUpdateCountry = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: CREATE_OR_UPDATE_COUNTRY,
      operationName: 'CREATE_OR_UPDATE_COUNTRY',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const country = data?.createOrUpdateCountry || {};
    if (country?._id) {
      dispatch(setIsRefreshCountry(true));
    }
    return country;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};

export const createOrUpdateBrand = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: CREATE_OR_UPDATE_BRAND,
      operationName: 'CREATE_OR_UPDATE_BRAND',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const brand = data?.createOrUpdateBrand || {};
    if (brand?.brandId) {
      dispatch(setIsRefreshBrands(true));
    }
    return brand;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};

export const createOrUpdateStore = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: CREATE_OR_UPDATE_STORE,
      operationName: 'CREATE_OR_UPDATE_STORE',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const store = data?.createOrUpdateStore || {};
    if (store?.storeId) {
      dispatch(setIsRefreshOrganizationTree(true));
    }
    return store;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};

export const createOrganization = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: CREATE_ORGANIZATION,
      operationName: 'CREATE_ORGANIZATION',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const organization = data?.createOrganization || {};
    if (organization?.organizationId) {
      dispatch(setIsRefreshOrganizations(true));
    }
    return organization;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};

export const getBrands = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.query({
      query: GET_BRANDS,
      operationName: 'GET_BRANDS',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const brands = data?.brands || {};
    dispatch(setBrands(brands));
    return brands;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};

export const getPermissions = async () => {
  try {
    const { data } = await ApolloClientPromoService.query({
      query: GET_PERMISSIONS,
      operationName: 'GET_PERMISSIONS',
      fetchPolicy: 'network-only',
    });
    const permissions = data?.permissions || {};
    return permissions;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};

export const createOrUpdatePermissions = async (input) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: CREATE_OR_UPDATE_PERMISSION,
      operationName: 'CREATE_OR_UPDATE_PERMISSION',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const permission = data?.createOrUpdatePermission || {};
    return permission;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};

export const createOrUpdateRole = async (input) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: CREATE_OR_UPDATE_ROLE,
      operationName: 'CREATE_OR_UPDATE_ROLE',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const role = data?.createOrUpdateRole || {};
    return role;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};

export const getRoles = async (variables) => {
  try {
    const { data } = await ApolloClientPromoService.query({
      query: GET_ROLES,
      operationName: 'GET_ROLES',
      fetchPolicy: 'network-only',
      variables: variables,
    });
    const roles = data?.roles || {};
    return roles;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};
